import React from "react";

function TextFieldWithLabel(props){
    return (
        <div className={"pt-4 block"}>
            <label className={"text-white"} htmlFor={props.fieldName}>{props.fieldLabel}</label>
            <br />
            <input
                className={"w-full rounded-md mt-2 px-3 py-2"}
                type={"text"}
                id={props.fieldName}
                name={props.fieldName} {...props.register(props.fieldName, {
                    required: ('required' in props) ? props.required : true,
                    pattern: ('pattern' in props) ? props.pattern : undefined,
                })}
            />
            {props.errors[props.fieldName]?.type === "required" && <div className={"text-red-500"}>Required</div>}
            {props.errors[props.fieldName]?.type === "pattern" && <div className={"text-red-500"}>Please enter a valid {props.fieldLabel}</div>}
        </div>
    );
}

export default TextFieldWithLabel;
